import { FC, useContext } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "@/assets/images/companyLogoUpdated.svg?react";
import { useAppSelector } from "@/app/hooks";
import LanguageSelector from "../LanguageSelector";
import ThemeSelector from "../ThemeSelector";
import { ThemeContext } from "@/Misc/ThemeContext";
import cacheManager from "@/utils/cacheManager";
interface IHeaderProps {
  setShowAc: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Header: FC<IHeaderProps> = () => {
  const { themeGradient } = useContext(ThemeContext);
  const {
    teams,
    activeTeam,
    activeProject,
    activeEnvironment,
    projectList: projects,
    envList: enviromentList,
  } = useAppSelector((state) => state.appGlobal);

  const navigate = useNavigate();

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      p={1}
      gap={1}
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        height: 55,
        background: themeGradient,
        color: "white",
      }}
    >
      <CompanyLogo />

      <Box flex={1} />
      {activeTeam?.teamId ? (
        <>
          {/* <Tooltip title="Select Team">
            <Button
              startIcon={<Groups2Outlined />}
              endIcon={<ArrowDropDownOutlined />}
              onClick={(e) => setTeamAnchor(e.currentTarget)}
              sx={{ color: "white", bgcolor: "transparent" }}
              id="snr-ai-Header-selectTeam"
            >
              {activeTeam.teamName}
            </Button>
          </Tooltip>
          <Menu
            anchorEl={teamAnchor}
            open={Boolean(teamAnchor)}
            onClose={() => setTeamAnchor(null)}
          >
            {Array.isArray(teams) &&
              teams?.map((team) => (
                <MenuItem
                  selected={activeTeam?.teamId === team.teamId}
                  key={team.teamId}
                  onClick={() => {
                    const selectedTeam = team;
                    navigate(COMPANY_INFORMATION_PATH);
                    dispatch(setActiveTeam(selectedTeam));
                    setTeamAnchor(null);
                  }}
                  id={`snr-ai-Header-team-${team.teamId}`}
                >
                  {team.teamName}
                </MenuItem>
              ))}
          </Menu> */}
        </>
      ) : null}
      {activeProject?.workspaceId ? (
        <>
          {/* <Tooltip title="Select Project">
            <Button
              startIcon={<WorkOutlined />}
              endIcon={<ArrowDropDownOutlined />}
              onClick={(e) => setProjectAnchor(e.currentTarget)}
              sx={{ color: "white", bgcolor: "transparent" }}
              id="snr-ai-Header-selectProject"
            >
              {activeProject.title}
            </Button>
          </Tooltip>
          <Menu
            anchorEl={projectAnchor}
            open={Boolean(projectAnchor)}
            onClose={() => setProjectAnchor(null)}
          >
            {Array.isArray(projects)
              ? projects?.map((project: any) => (
                  <MenuItem
                    selected={
                      activeProject?.workspaceId === project.workspaceId
                    }
                    key={project.workspaceId}
                    onClick={() => {
                      const selectedProject = project;
                      dispatch(
                        setTeamActiveProject({
                          teamId: activeTeam?.teamId,
                          project: selectedProject,
                        })
                      );
                      // navigate(`/company-settings/api-collection`);
                      navigate(COMPANY_INFORMATION_PATH);
                      setProjectAnchor(null);
                    }}
                    id={`snr-ai-Header-project-${project.workspaceId}`}
                  >
                    {project.title}
                  </MenuItem>
                ))
              : null}
          </Menu> */}
        </>
      ) : null}
      <>
        {/* <Tooltip title="Select Environment">
          <Button
            startIcon={<SettingsOutlined />}
            endIcon={<ArrowDropDownOutlined />}
            onClick={(e) => setEnvAnchor(e.currentTarget)}
            sx={{ color: "white", bgcolor: "transparent" }}
            disabled={!enviromentList}
            id="snr-ai-Header-selectEnvironment"
          >
            {activeEnvironment?.envName || "Select Environment"}
          </Button>
        </Tooltip>
        <Menu
          anchorEl={envAnchor}
          open={Boolean(envAnchor)}
          onClose={() => setEnvAnchor(null)}
        >
          {Array.isArray(enviromentList)
            ? enviromentList?.map((env: any) => (
                <MenuItem
                  selected={activeEnvironment?.appEnvId === env.appEnvId}
                  key={env.appEnvId}
                  onClick={() => {
                    const selectedEnvironment = env;
                    dispatch(
                      setActiveEnvironment({
                        environment: selectedEnvironment,
                      })
                    );
                    setEnvAnchor(null);
                  }}
                  id={`snr-ai-Header-environment-${env.appEnvId}`}
                >
                  {env.envName}
                </MenuItem>
              ))
            : null}
        </Menu> */}
      </>

      {/* <Button
        onClick={() => {
          setShowAc(true);
        }}
      >
        Add accessToken
      </Button> */}
      <LanguageSelector />
      <ThemeSelector />
      <Button
        onClick={async () => {
          await cacheManager.clear();
          localStorage.clear();
          navigate("/");
        }}
        id="snr-ai-Header-reset"
      >
        Reset
      </Button>
    </Box>
  );
};
